module.exports = __webpack_public_path__ + "static/media/wakoframe1.ad7d50c6.png";